import { useLoaderStore } from '@/store/loader'
import { AnimatePresence, motion } from 'framer-motion'
import { useLayoutEffect } from 'react'

// LoaderNotifier job is to notify only
export const LoaderNotifier = () => {
  const { increment, decrement } = useLoaderStore()
  useLayoutEffect(() => {
    increment()
    return () => decrement()
  }, [])
  return <></>
}
export const Loader = () => {
  const { count } = useLoaderStore()

  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-40 flex items-center justify-center bg-black"
        >
          <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
